import { EntityId } from "@jackfruit/common"
import React from "react"
import { CloudProviderType } from "./CloudProviderTypes"
import { useCloudProviderContext } from "./hooks/useCloudProviderContext"

interface Props {
  children: React.ReactElement
  cloudProviderType?: CloudProviderType
  lineItemId?: EntityId
  imageRegionId?: EntityId
  isEnabled?: boolean
}

const CloudProviderHandler: React.FC<Props> = ({
  children,
  cloudProviderType,
  lineItemId,
  imageRegionId,
  isEnabled = true,
}) => {
  const {
    openCloudProviderModal,
    setCurrentCloudProvider,
    setLineItemId,
    setImageRegionId,
  } = useCloudProviderContext()

  const enhancedChildren = React.cloneElement(children, {
    onClick: () => {
      if (isEnabled) {
        if (cloudProviderType) {
          setCurrentCloudProvider(cloudProviderType)
        }
        setLineItemId(lineItemId ?? null)
        setImageRegionId(imageRegionId ?? null)

        openCloudProviderModal()
      }
    },
  })

  return enhancedChildren
}

export default CloudProviderHandler
